import { makeStyles, Theme } from '@material-ui/core'
import { ValueLabelProps } from 'components/Common/ValueLabel/ValueLabel'
import { MoneyString } from 'model/Money'
import { useTranslation } from 'react-i18next'
import { useAppSelector } from 'store/configureStore'
import {
  MoneyDto,
  PriceScope,
} from 'services/APIs/InternalAPI/internal-api.contracts'
import { saveBomItemMaterialCostPrice } from '../store/asyncActions/saveBomItemMaterialCostPrice'
import { ProjectTextField } from '../store/components/ProjectTextField'
import { ValueLabelConnected } from '../store/components/ValueLabelConnected'
import { bomItemFinancialSelector } from '../store/selectors/bomItemFinancialSelector'
import { bomItemIsPurchasingPartSelector } from '../store/selectors/bomItemIsPurchasingPartSelector'
import { ProjectEditableStateSelector } from '../store/selectors/ProjectEditableStateSelector'
import { ProjectInBuyerViewSelector } from '../store/selectors/projectInBuyerViewSelector'
import { valueGreaterThanZero } from '../Validations/valueGreaterThanZero'

export const useBomItemPricePerBatchStyles = makeStyles((theme: Theme) => ({
  moneyTextField: {
    width: (props?: { fullWidth?: boolean }) =>
      props.fullWidth ? '100%' : `${theme.spacing(11)}px`,
    '& label': {
      transform: 'translate(0px, 1.5px) scale(0.75)',
      transformOrigin: 'top right',
      left: 'unset',
      right: 0,
    },
  },
  targetPrice: {
    display: 'absolute',
  },
}))

export const BomItemPricePerBatch = ({
  bomItemId,
  label,
  valueLabelProps,
  fullWidth = false,
}: {
  bomItemId: string
  label?: string
  valueLabelProps?: Partial<ValueLabelProps>
  fullWidth?: boolean
}) => {
  const { t } = useTranslation()
  const isPurchasingPart = useAppSelector(
    bomItemIsPurchasingPartSelector(bomItemId)
  )
  const cn = useBomItemPricePerBatchStyles({ fullWidth })

  const projectIsEditable = useAppSelector(ProjectEditableStateSelector)
  const isBuyerView = useAppSelector(ProjectInBuyerViewSelector)

  if (!isPurchasingPart || !projectIsEditable || isBuyerView) {
    return (
      <ValueLabelConnected
        propertySelector={(state) =>
          MoneyString(
            bomItemFinancialSelector(
              bomItemId,
              'salesPricePerItem'
            )(state) as MoneyDto
          )
        }
        valueLabelProps={{
          label: label || t('project:price-per-batch'),
          valueProps: {
            style: { width: fullWidth ? '100%' : '90px' },
          },
          ...valueLabelProps,
        }}
      />
    )
  }

  return (
    <ProjectTextField
      valueSelector={bomItemFinancialSelector(bomItemId, 'salesPricePerItem')}
      saveAction={(value) =>
        saveBomItemMaterialCostPrice({
          bomItemId: bomItemId,
          materialCostPrice: value,
          priceScope: PriceScope.Unit,
        })
      }
      actionTypePrefix={saveBomItemMaterialCostPrice.typePrefix.concat(
        '/',
        bomItemId
      )}
      money
      disableShowHelpText
      textFieldProps={{
        // type: 'number',
        label: label || t('project:price-per-batch'),
        className: cn.moneyTextField,
        required: true,
        inputProps: {
          style: {
            textAlign: 'right',
            width: fullWidth ? '100%' : '90px',
          },
        },
      }}
      validation={valueGreaterThanZero}
    />
  )
}
